import React from 'react';
import { useModal, useModalTitle } from '@topconagriculture/modal';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { DeviationWidgetL } from '../DeviationWidgetL/DeviationWidgetL';
import { WidgetType } from '../../../widget.types';
const useStyles = makeStyles(() => ({
    modalContainer: {
        minWidth: 1000,
        overflow: 'hidden',
        paddingTop: 20,
    },
}));
export const modalTitleMap = {
    [WidgetType.DELIVER_DEVIATION]: 'widget:deliver_deviation:title',
    [WidgetType.LOAD_DEVIATION]: 'widget:load_deviation:title',
};
export const DeviationWidgetLModal = () => {
    const { t } = useTranslation();
    const { modalParams } = useModal();
    useModalTitle(t(modalTitleMap[modalParams.widget.type]));
    const classes = useStyles();
    return (React.createElement("div", { className: classes.modalContainer },
        React.createElement(DeviationWidgetL, null)));
};
//# sourceMappingURL=DeviationWidgetLModal.js.map